import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faTwitter,
  // faLinkedinIn,
  faInstagram,
  faYoutube,
  faWhatsapp,
  // faTelegram,
} from "@fortawesome/free-brands-svg-icons";
// function SocialNavbar() {
const SocialNavbar = ({
  facebookUrl,
  twitterUrl,
  instagramUrl,
  youtubeUrl,
  telegramUrl,
  whatsappUrl,
}) => {
  return (
    <div className="social-navbar">
      <a
        href={facebookUrl}
        target="_blank"
        rel="noreferrer"
        className="social-link"
      >
        <FontAwesomeIcon icon={faFacebookF} />
      </a>
      <a
        href={twitterUrl}
        target="_blank"
        rel="noreferrer"
        className="social-link"
      >
        <FontAwesomeIcon icon={faTwitter} />
      </a>
      {/* <a
        href="https://linkedin.com"
        target="_blank"
        rel="noreferrer"
        className="social-link"
      >
        <FontAwesomeIcon icon={faLinkedinIn} />
      </a> */}
      <a
        href={instagramUrl}
        target="_blank"
        rel="noreferrer"
        className="social-link"
      >
        <FontAwesomeIcon icon={faInstagram} />
      </a>
      <a
        href={youtubeUrl}
        target="_blank"
        rel="noreferrer"
        className="social-link"
      >
        <FontAwesomeIcon icon={faYoutube} />
      </a>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noreferrer"
        className="social-link"
      >
        <FontAwesomeIcon icon={faWhatsapp} />
      </a>
      {/* <a
        href={telegramUrl}
        target="_blank"
        rel="noreferrer"
        className="social-link"
      >
        <FontAwesomeIcon icon={faTelegram} />
      </a> */}
    </div>
  );
};

export default SocialNavbar;
